import { MapPin, Building2, Factory, Users } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const InfrastructureSection = () => {
  const { t } = useLanguage();

  const partners = [
    { icon: Building2, text: t('infrastructure.cities') },
    { icon: Factory, text: t('infrastructure.utilities') },
    { icon: Users, text: t('infrastructure.integrators') },
  ];

  return (
    <section id="about" className="py-20 md:py-32 bg-white" data-testid="infrastructure-section">
      <div className="container-0g">
        <div className="max-w-4xl mx-auto text-center">
          <p className="section-label">{t('infrastructure.label')}</p>
          <h2 className="section-title mb-6">
            {t('infrastructure.title')}
          </h2>
          <p className="text-lg text-slate-600 mb-12 leading-relaxed">
            {t('infrastructure.subtitle')}
          </p>

          {/* Partner types */}
          <div className="flex flex-wrap justify-center gap-8 mb-12">
            {partners.map((partner, index) => {
              const Icon = partner.icon;
              return (
                <div 
                  key={index} 
                  className="flex items-center space-x-3"
                  data-testid={`infra-partner-${index}`}
                >
                  <div className="w-12 h-12 rounded-sm bg-white border border-slate-200 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-teal-600" />
                  </div>
                  <span className="font-medium text-slate-700">{partner.text}</span>
                </div>
              );
            })}
          </div>

          {/* Map representation */}
          <div className="relative bg-white border border-slate-200 rounded-sm p-8 md:p-12">
            <div className="grid grid-cols-3 gap-4 md:gap-8">
              {/* Estonia */}
              <div className="text-center" data-testid="map-estonia">
                <div className="w-16 h-16 mx-auto rounded-full bg-teal-600/10 flex items-center justify-center mb-3">
                  <MapPin className="h-8 w-8 text-teal-600" />
                </div>
                <p className="font-semibold text-slate-900">{t('countries.estonia')}</p>
                <p className="text-sm text-slate-500">Tallinn</p>
              </div>
              
              {/* Latvia */}
              <div className="text-center" data-testid="map-latvia">
                <div className="w-16 h-16 mx-auto rounded-full bg-teal-600/10 flex items-center justify-center mb-3">
                  <MapPin className="h-8 w-8 text-teal-600" />
                </div>
                <p className="font-semibold text-slate-900">{t('countries.latvia')}</p>
                <p className="text-sm text-slate-500">Riga</p>
              </div>
              
              {/* Lithuania */}
              <div className="text-center" data-testid="map-lithuania">
                <div className="w-16 h-16 mx-auto rounded-full bg-teal-600/10 flex items-center justify-center mb-3">
                  <MapPin className="h-8 w-8 text-teal-600" />
                </div>
                <p className="font-semibold text-slate-900">{t('countries.lithuania')}</p>
                <p className="text-sm text-slate-500">Vilnius</p>
              </div>
            </div>
            
            {/* Connecting lines visual */}
            <div className="absolute top-1/2 left-1/4 right-1/4 h-0.5 bg-gradient-to-r from-teal-600/20 via-teal-600 to-teal-600/20 -translate-y-1/2 hidden md:block" />
          </div>
        </div>
      </div>
    </section>
  );
};
